<template lang="html">
    <div class="placebadge" v-bind:class="{'gold': primary, 'white': !primary, 'small': isSmall()}">
        Locul <b>{{place}}</b>
    </div>
</template>

<script>

export default {
    name: 'PlaceBadge',
    components: {
    },
    props: {
        place: '',
        primary: false,
        size: {
            type: String,
            default: 'normal'
        }
    },
    computed: {
    },
    watch: {
    },
    data: function() {
        return {}
    },
    mounted() {
    },
    methods: {

        isSmall() {
            return this.size == 'small';
        }
    }
}
</script>

<style lang="scss" scoped>

.placebadge {
    display: inline-block;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    text-align: center;
    vertical-align: top;
    font-size: 11px;
    padding-top: 10px;
    line-height: 12px;

    &.white {
        background: white;
        border: solid 1px #dee2e6;
        color: #333;
    }

    &.gold {
        background: #F7AD0C;
        color: #fff;
    }

    b {
        display: block;
        font-size: 20px;
        padding-top: 5px;
        color: #333;
    }

    &.small {

        width: 40px;
        height: 40px;
        padding-top: 5px;
        font-size: 10px;

        b {
            font-size: 15px;
        }
    }
}

</style>
